var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0005 0.167969C5.03297 0.167969 0.167969 5.02422 0.167969 11.0005C0.167969 13.0742 0.745469 15.0605 1.83922 16.7842L0.237969 20.6255C0.115469 20.923 0.167969 21.273 0.377969 21.5267C0.544219 21.7192 0.789219 21.833 1.04297 21.833C1.11297 21.833 1.18297 21.8242 1.24422 21.8067L6.14422 20.678C7.64047 21.4392 9.31172 21.833 11.0005 21.833C16.9767 21.833 21.833 16.9767 21.833 11.0005C21.833 5.02422 16.9767 0.167969 11.0005 0.167969ZM14.5005 11.8755H11.8755V14.5005C11.8755 14.9817 11.4817 15.3755 11.0005 15.3755C10.5192 15.3755 10.1255 14.9817 10.1255 14.5005V11.8755H7.50047C7.01922 11.8755 6.62547 11.4817 6.62547 11.0005C6.62547 10.5192 7.01922 10.1255 7.50047 10.1255H10.1255V7.50047C10.1255 7.01922 10.5192 6.62547 11.0005 6.62547C11.4817 6.62547 11.8755 7.01922 11.8755 7.50047V10.1255H14.5005C14.9817 10.1255 15.3755 10.5192 15.3755 11.0005C15.3755 11.4817 14.9817 11.8755 14.5005 11.8755Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewChat);
export default __webpack_public_path__ + "static/media/newChat.974190ccea183505f5409cd6f2c1c981.svg";
export { ForwardRef as ReactComponent };